import {Component, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {BaseComponent} from "@wms/components";
import {FormsModule} from "@angular/forms";
import {some} from "lodash-es";
import {NotificationService} from "@wms/services";

@Component({
  selector: 'wms-ptt-configuration',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.less']
})
export class ConfigurationComponent extends BaseComponent implements OnInit {

  @Input() artifactPublishDetails: any;

  metadataObjs: any[];

  constructor(private notificationService: NotificationService) {
    super();
  }

  ngOnInit() {
    this.metadataObjs = [];
    this.getMetadata();
  }

  addTag() {
    let tag = this.artifactPublishDetails.tag; this.artifactPublishDetails.tag = "";
    if(tag && !this.isTagPresent(tag) && tag !== "") {
      this.artifactPublishDetails.tags.push(tag);
    }
  }

  private isTagPresent(tag: string) {
    let isTagPresent = some(this.artifactPublishDetails.tags, (existingTag: string) => {
      return existingTag.toLowerCase() === tag.toLowerCase();
    });
    return isTagPresent;
  }

  getMetadata() {
    if(!this.metadataObjs.length) {
      this.projectService.getSystemMetadata().then((metadataObjs: any) => {
        metadataObjs.push({
          key     : "platformVersion",
          value   : this.projectService.getDetails().platformVersion
        });
        this.metadataObjs = this.artifactPublishDetails.metadataObjs = metadataObjs;
      }, (error: any) => {
        this.notificationService.show('error', this.locale.MESSAGE_ERROR_TITLE, error);
      });
    }
  }

  onTagKeyPress($event: KeyboardEvent) {
    if($event.key === 'Enter')
      this.addTag();
  }
}
